// extracted by mini-css-extract-plugin
export default {"container":"mD-z","dimension":"nD-z","dimensionLabels":"oD-z"};